import Mang from "../layout/Mang";
import Grid from "@mui/material/Grid";
import Cards from "../layout/Cards";
import ezar from "../assets/ezar.png";
import travel from "../assets/travel.png";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
const Work = () => {
  return (
    <>
      <Container maxWidth="md">
        <Grid xs={12} sx={{marginTop:"5rem" , marginBottom:"4rem"}}>
          <Mang />
        </Grid>
        <Grid xs={12}>
        <Paper
            sx={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              marginTop: "1rem",
              marginBottom: "4rem",
              marginLeft:"7rem",
              padding: ".5rem",
              background: "rgba(255, 173, 1, 0.5)",
              width: "70%",
              borderRadius: "10px",
            }}
          >
            <Typography
              variant="h6"
              component="div"rem
              sx={{ flexGrow: 1, display: "flex", justifyContent: "center" , color:"white" }}
            >
              Every project has challenges, and every project has its rewards.
            </Typography>
          </Paper>
        </Grid>
        <Box
          sx={{display:"flex" , justifyContent:"center" , alignItems:"center" , marginLeft:"2rem"  }}

        >
           
       <Grid item xs={12} md={12} xl={6} lg={6}>
            <Cards
              height="350px"
              img={ezar}
              alt="ezar meals logo"
              title="Ezar meals"
              desc="Ezar meals is a web application that helps you to find the best meals for your daily needs using the best recipes from the best chefs in the world , the application was built using Reactjs Firbase as database "
              link="https://github.com/Omarhussian/foodorder"
            />
           
           </Grid>
             
           <Grid item  xs={12} md={12} xl={6} lg={6}>
            <Cards
              height="330px"
              img={travel}
              alt="Travel your Way  logo"
              title="Travel Your Way"
              desc="Travel your way is an advanced Travel Companion Application using Google Maps. With Geolocation, Google Maps API, Searching for places, Fetching restaurants, hotels and attractions based on location from specialized Rapid APIs, data filtering and much more."
              link="https://github.com/Omarhussian/travelway"
            />
              </Grid>
          
          
        </Box>
      </Container>
    </>
  );
};
export default Work;
